export const TICKETS_HEADER_ACTIONS = Object.freeze({
    MARK_TICKET_AS_READ: "MARK_TICKET_AS_READ",
    CLOSE_TICKET: "CLOSE_TICKET",
    SNOOZE_TICKET: "SNOOZE_TICKET",
});
